var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacher"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar}}),_c('h4',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"job"},[_vm._v(_vm._s(_vm.jobs))])])}
var staticRenderFns = []

export { render, staticRenderFns }